import { render } from "./ContactsPeopleOverview.vue?vue&type=template&id=535b2a1c"
import script from "./ContactsPeopleOverview.vue?vue&type=script&lang=js"
export * from "./ContactsPeopleOverview.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__